import { normalizeRoleCodeToken } from "./audit-token-normalizers.js";

export function resolveRoleCodeFromUserRoleSlot(role) {
  if (role == null) return "";
  if (typeof role === "string" || typeof role === "number") {
    return normalizeRoleCodeToken(role);
  }
  return normalizeRoleCodeToken(
    role?.role_code ?? role?.roleCode ?? role?.name ?? role?.code,
  );
}
